import { Card } from '@/components/ui/card'
import AdPlaybackStats from './AdPlaybackStats'
import PeopleFlowStats from './PeopleFlowStats'
import ConnectionStatus from './ConnectionStatus'

export default function RightSidePanel() {
  return (
    <div className="fixed right-4 top-4 bottom-4 z-10 w-80">
      <Card className="h-full bg-white/95 backdrop-blur-sm shadow-lg hover:shadow-xl transition-shadow">
        <div className="h-full flex flex-col p-4 gap-4">
          {/* 廣告播放統計 */}
          <div className="flex-1">
            <AdPlaybackStats />
          </div>

          {/* 人流統計 */}
          <div className="flex-1">
            <PeopleFlowStats />
          </div>

          {/* 連線狀態 */}
          <div className="flex-1">
            <ConnectionStatus />
          </div>
        </div>
      </Card>
    </div>
  )
}
